import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./Media.module.css";
import NavSlider from "../NavSlider/NavSlider";

/* =========================================================
   VIDEO DATA
========================================================= */

const videoData = [
  {
    id: 1,
    title: "React.js Complete Course 2026 - Build Modern Web Apps",
    channel: "Code Master",
    views: "1.2M views",
    time: "2 days ago",
    duration: "14:20",
    category: "React",
    thumbnail:
      "https://images.unsplash.com/photo-1633356122544-f134324a6cee?auto=format&fit=crop&w=600&q=80",
    avatar:
      "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=150&q=80",
  },

  {
    id: 2,
    title: "Top 10 Mobile UI/UX Design Trends in 2026",
    channel: "Design Hub",
    views: "450K views",
    time: "1 week ago",
    duration: "08:45",
    category: "UI/UX",
    thumbnail:
      "https://images.unsplash.com/photo-1616469829941-c7200edec809?auto=format&fit=crop&w=600&q=80",
    avatar:
      "https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?auto=format&fit=crop&w=150&q=80",
  },

  {
    id: 3,
    title: "10 Minute Full Body Workout at Home (No Equipment)",
    channel: "Fit Life",
    views: "890K views",
    time: "3 days ago",
    duration: "10:15",
    category: "Fitness",
    thumbnail:
      "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?auto=format&fit=crop&w=600&q=80",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&q=80",
  },

  {
    id: 4,
    title: "Relaxing Lo-Fi Chill Beats to Study / Relax to",
    channel: "Chill Lounge",
    views: "3.4M views",
    time: "2 weeks ago",
    duration: "45:00",
    category: "Music",
    thumbnail:
      "https://images.unsplash.com/photo-1518609878373-06d740f60d8b?auto=format&fit=crop&w=600&q=80",
    avatar:
      "https://images.unsplash.com/photo-1527980965255-d3b416303d12?auto=format&fit=crop&w=150&q=80",
  },
];

/* =========================================================
   CATEGORIES
========================================================= */

const categories = [
  "All",
  "React",
  "Music",
  "UI/UX",
  "Fitness",
  "Gaming",
  "Podcasts",
];

/* =========================================================
   MEDIA COMPONENT
========================================================= */

export default function Media() {
  const navigate = useNavigate();

  /* =======================================================
       GET URL PARAMETERS
       
       Example:
       /1/87f78c6c-1d51-4bf6-8e84-64bd8ef773e2/wallet
  
       userId     = 1
       deviceUuid = 87f78c6c-1d51-4bf6-8e84-64bd8ef773e2
    ======================================================= */
  
    const { userId, deviceUuid } = useParams();
  
    console.log("Wallet userId:", userId);
    console.log("Wallet deviceUuid:", deviceUuid); 
      /* =======================================================
     BASE PATH
  ======================================================= */

  const basePath = `/${userId}/${deviceUuid}`;

   /* =======================================================
       ACTIVE BOTTOM NAV
    ======================================================= */
  
    const [activeTab, setActiveTab] = useState("media");



  /* =======================================================
     SEARCH
  ======================================================= */

  const [searchQuery, setSearchQuery] = useState("");

  /* =======================================================
     CATEGORY
  ======================================================= */

  const [activeCategory, setActiveCategory] = useState("All");

  /* =======================================================
     BOTTOM NAVIGATION
  ======================================================= */

  const [activeNav, setActiveNav] = useState("media");
   const goTo = (tab, page) => {
    setActiveTab(tab);

    navigate(`${basePath}/${page}`);
  };

  /* =======================================================
     MENU / NAV SLIDER
  ======================================================= */

  const [menuOpen, setMenuOpen] = useState(false);

  /* =======================================================
     MENU HANDLER
  ======================================================= */

  const handleMenu = () => {
    setMenuOpen(true);
  };

 

  /* =======================================================
     FILTER VIDEOS
  ======================================================= */

  const filteredVideos = videoData.filter((video) => {
    const query = searchQuery.trim().toLowerCase();

    const matchesSearch =
      video.title.toLowerCase().includes(query) ||
      video.channel.toLowerCase().includes(query) ||
      video.category.toLowerCase().includes(query);

    const matchesCategory =
      activeCategory === "All" ||
      video.category === activeCategory;

    return matchesSearch && matchesCategory;
  });

  /* =======================================================
     RENDER
  ======================================================= */

  return (
    <div className={styles.iosScreenWrapper}>

      {/* =====================================================
          NAV SLIDER
      ====================================================== */}

      <NavSlider
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        navigate={navigate}
      />

      {/* =====================================================
          DEVICE FRAME
      ====================================================== */}

      <div className={styles.iosDeviceFrame}>

        {/* =================================================
            SCROLL BODY
        ================================================= */}

        <div className={styles.iosScrollContainer}>

          {/* ===============================================
              HEADER
          =============================================== */}

          <header className={styles.mediaHeader}>

            <div className={styles.headerTopBar}>

              {/* MEDIA LOGO */}

              <div className={styles.ytLogo}>

                <svg
                  width="30"
                  height="22"
                  viewBox="0 0 30 22"
                  fill="none"
                  aria-hidden="true"
                >
                  <rect
                    width="30"
                    height="22"
                    rx="6"
                    fill="#FF0000"
                  />

                  <polygon
                    points="12,6 21,11 12,16"
                    fill="#FFFFFF"
                  />
                </svg>

                <span className={styles.logoText}>
                  Media
                </span>

              </div>

              {/* HAMBURGER */}

              <button
                type="button"
                className={styles.menuHamburgerBtn}
                aria-label="Open Menu"
                onClick={handleMenu}
              >

                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#0066cc"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  aria-hidden="true"
                >

                  <line
                    x1="3"
                    y1="6"
                    x2="21"
                    y2="6"
                  />

                  <line
                    x1="3"
                    y1="12"
                    x2="21"
                    y2="12"
                  />

                  <line
                    x1="3"
                    y1="18"
                    x2="21"
                    y2="18"
                  />

                </svg>

              </button>

            </div>

          </header>

          {/* ===============================================
              SEARCH INPUT
          =============================================== */}

          <div className={styles.searchBarWrapper}>

            <input
              type="text"
              placeholder="Search videos..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className={styles.searchInput}
              aria-label="Search videos"
            />

            <svg
              className={styles.searchIcon}
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              aria-hidden="true"
            >

              <circle
                cx="11"
                cy="11"
                r="8"
              />

              <line
                x1="21"
                y1="21"
                x2="16.65"
                y2="16.65"
              />

            </svg>

          </div>

          {/* ===============================================
              CATEGORY CHIPS
          =============================================== */}

          <div className={styles.categoriesScroll}>

            {categories.map((category) => (

              <button
                key={category}
                type="button"
                className={`${styles.categoryChip} ${
                  activeCategory === category
                    ? styles.active
                    : ""
                }`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>

            ))}

          </div>

          {/* ===============================================
              VIDEO FEED
          =============================================== */}

          <main className={styles.videoFeed}>

            {filteredVideos.length === 0 ? (

              <div className={styles.emptyState}>

                <p>
                  No videos found.
                </p>

                {(searchQuery || activeCategory !== "All") && (

                  <button
                    type="button"
                    onClick={() => {
                      setSearchQuery("");
                      setActiveCategory("All");
                    }}
                  >
                    Clear Filters
                  </button>

                )}

              </div>

            ) : (

              filteredVideos.map((video) => (

                <article
                  key={video.id}
                  className={styles.videoCard}
                >

                  {/* =====================================
                      THUMBNAIL
                  ====================================== */}

                  <div className={styles.thumbnailWrapper}>

                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className={styles.thumbnailImg}
                    />

                    <span className={styles.durationBadge}>
                      {video.duration}
                    </span>

                  </div>

                  {/* =====================================
                      VIDEO INFORMATION
                  ====================================== */}

                  <div className={styles.videoInfo}>

                    {/* CHANNEL AVATAR */}

                    <img
                      src={video.avatar}
                      alt={video.channel}
                      className={styles.channelAvatar}
                    />

                    {/* VIDEO META */}

                    <div className={styles.videoMeta}>

                      <h3 className={styles.videoTitle}>
                        {video.title}
                      </h3>

                      <p className={styles.channelName}>
                        {video.channel}
                      </p>

                      <p className={styles.videoSubtext}>
                        {video.views} • {video.time}
                      </p>

                    </div>

                  </div>

                </article>

              ))

            )}

          </main>

        </div>

        {/* =================================================
            BOTTOM NAVIGATION
        ================================================= */}

        <div className={styles.bottomNavWrapper}>

          <nav
            className={styles.bottomNav}
            aria-label="Bottom Navigation"
          >

            {/* =============================================
                HOME
            ============================================= */}

            <button
              type="button"
              className={`${styles.navBtn} ${
                activeNav === "home"
                  ? styles.active
                  : ""
              }`}
              onClick={() =>
                goTo("home", "userprofile")
              }
              aria-label="Home"
            >

              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >

                <path
                  d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                />

                <polyline
                  points="9 22 9 12 15 12 15 22"
                />

              </svg>

              <span className={styles.navLabel}>
                Home
              </span>

            </button>

            {/* =============================================
                SEARCH
            ============================================= */}

            <button
              type="button"
              className={`${styles.navBtn} ${
                activeNav === "search"
                  ? styles.active
                  : ""
              }`}
              // onClick={() =>
              //   handleNavigation(
              //     "search",
              //     "/search"
              //   )
              // }
              onClick={() =>
                goTo("search", "search")
              }
              aria-label="Search"
            >

              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                aria-hidden="true"
              >

                <circle
                  cx="11"
                  cy="11"
                  r="8"
                />

                <line
                  x1="21"
                  y1="21"
                  x2="16.65"
                  y2="16.65"
                />

              </svg>

              <span className={styles.navLabel}>
                Search
              </span>

            </button>

            {/* =============================================
                TASKS
            ============================================= */}

            <button
              type="button"
              className={`${styles.navBtn} ${
                activeNav === "tasks"
                  ? styles.active
                  : ""
              }`}
              
              onClick={() =>
                goTo("task", "tasks")
              }
              aria-label="Tasks"
            >

              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >

                <path
                  d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                />

                <rect
                  x="8"
                  y="2"
                  width="8"
                  height="4"
                  rx="1"
                />

                <path d="M8 11h8" />

                <path d="M8 15h5" />

              </svg>

              <span className={styles.navLabel}>
                Tasks
              </span>

            </button>

            {/* =============================================
                MEDIA
            ============================================= */}

            <button
              type="button"
              className={`${styles.navBtn} ${
                activeNav === "media"
                  ? styles.active
                  : ""
              }`}
              onClick={() =>
                goTo("media", "media")
              }
              aria-label="Media"
            >

              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >

                <polygon
                  points="5 3 19 12 5 21 5 3"
                />

              </svg>

              <span className={styles.navLabel}>
                Media
              </span>

            </button>

            {/* =============================================
                WALLET
            ============================================= */}

            <button
              type="button"
              className={`${styles.navBtn} ${
                activeNav === "wallet"
                  ? styles.active
                  : ""
              }`}
              onClick={() =>
                goTo("wallet", "wallet")
              }
              aria-label="Wallet"
            >

              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >

                <rect
                  x="2"
                  y="6"
                  width="20"
                  height="12"
                  rx="3"
                />

                <path d="M18 12h.01" />

              </svg>

              <span className={styles.navLabel}>
                Wallet
              </span>

            </button>

          </nav>

        </div>

      </div>

    </div>
  );
}